import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-xl modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "modal-title" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "error" }
const _hoisted_12 = { class: "table table-bordered table-hover" }
const _hoisted_13 = {
  key: 0,
  type: "number",
  disabled: "",
  value: "100",
  class: "form-control"
}
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = { class: "error" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "modal-footer" }

import { computed, toRef } from 'vue'
    import type { PropType } from 'vue'
    import { EditorState } from "@common/Common"
    import type { RawCriterionWeight } from "@Criteria/Model"
    import type { WeightsSetEditorViewModel, WeightsSetEditorCreateWeightsSetEventPayload, WeightsSetEditorUpdateWeightsSetEventPayload, WeightsSetEditorNormalizeWeightsEventPayload } from "@Criteria/Weights/Components/WeightsSetEditor"

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'WeightsSetEditor',
  props: {
        viewModel: {
            type: Object as PropType<WeightsSetEditorViewModel>,
            required: true
        }
    },
  emits: ["create-weights-set", "update-weights-set", "normalize-weights"],
  setup(__props, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- state ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- computed ----------------

    const opened = computed(() => vm.value.editorState !== EditorState.Closed)
    const initialized = computed(() => vm.value.initialized)
    const criteria = computed(() => vm.value.criteria)

    const nameError = computed(() =>
        vm.value.errors.find(e => e.ErrorCode?.startsWith("Name."))?.Error ?? null
    )

    const hasDirtyWeights = computed(() =>
        criteria.value.some(c => c.localWeight !== c.inputValue)
    )

    const title = computed(() =>
    {
        if (vm.value.editorState === EditorState.Creator) return "Create weights set"
        if (vm.value.editorState === EditorState.Editor) return "Edit weights set"
        return null
    })

    // ---------------- helpers ----------------

    function getError(criterionId: number): string | null
    {
        const err = vm.value.errors.find(e => e.Context === criterionId.toString())
        return err?.Error ?? null
    }

    // ---------------- actions ----------------

    function emitFormSubmit()
    {
        vm.value.errors = []

        const weights: RawCriterionWeight[] =
            criteria.value.map(c => ({ CriterionId: c.id, LocalWeight: c.inputValue }))

        if (vm.value.editorState === EditorState.Creator)
        {
            emit("create-weights-set", {
                name: vm.value.name,
                weights
            })
        }
        else if (vm.value.editorState === EditorState.Editor)
        {
            emit("update-weights-set", {
                weightsSetId: vm.value.weightsSetId!,
                name: vm.value.name,
                weights
            })
        }
    }

    function emitNormalizeWeights()
    {
        const weights: RawCriterionWeight[] =
            criteria.value.map(c => ({ CriterionId: c.id, LocalWeight: c.inputValue }))

        emit("normalize-weights", { weights })
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h5", _hoisted_6, _toDisplayString(title.value), 1 /* TEXT */),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: close
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_7, [
                (!initialized.value)
                  ? (_openBlock(), _createElementBlock("h3", _hoisted_8, [...(_cache[1] || (_cache[1] = [
                      _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                      _createTextVNode(" Loading... ", -1 /* CACHED */)
                    ]))]))
                  : _createCommentVNode("v-if", true),
                (initialized.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("form", {
                        id: "weights-set-editor-form",
                        onSubmit: _withModifiers(emitFormSubmit, ["prevent"])
                      }, [
                        _createElementVNode("div", _hoisted_10, [
                          _cache[2] || (_cache[2] = _createElementVNode("label", null, "Name:", -1 /* CACHED */)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((vm.value.name) = $event)),
                            type: "text",
                            class: "form-control",
                            required: "",
                            minlength: "2",
                            maxlength: "100"
                          }, null, 512 /* NEED_PATCH */), [
                            [
                              _vModelText,
                              vm.value.name,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          _createElementVNode("div", _hoisted_11, _toDisplayString(nameError.value), 1 /* TEXT */)
                        ]),
                        _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                        _createElementVNode("table", _hoisted_12, [
                          _cache[4] || (_cache[4] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", { rowspan: "2" }, "Criterion"),
                              _createElementVNode("th", {
                                rowspan: "2",
                                style: {"width":"150px"}
                              }, "Input"),
                              _createElementVNode("th", { colspan: "2" }, "Normalized weight [%]")
                            ]),
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", { style: {"width":"150px"} }, "Local"),
                              _createElementVNode("th", { style: {"width":"150px"} }, "Global")
                            ])
                          ], -1 /* CACHED */)),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(criteria.value, (c) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: c.id
                              }, [
                                _createElementVNode("td", null, [
                                  _createTextVNode(_toDisplayString(c.name), 1 /* TEXT */),
                                  _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                                  _createElementVNode("small", null, _toDisplayString(c.path), 1 /* TEXT */)
                                ]),
                                _createElementVNode("td", null, [
                                  (c.isGoal)
                                    ? (_openBlock(), _createElementBlock("input", _hoisted_13))
                                    : _withDirectives((_openBlock(), _createElementBlock("input", {
                                        key: 1,
                                        type: "number",
                                        "onUpdate:modelValue": ($event: any) => ((c.inputValue) = $event),
                                        min: "0",
                                        step: "any",
                                        class: "form-control"
                                      }, null, 8 /* PROPS */, _hoisted_14)), [
                                        [
                                          _vModelText,
                                          c.inputValue,
                                          void 0,
                                          { number: true }
                                        ]
                                      ]),
                                  _createElementVNode("div", _hoisted_15, _toDisplayString(getError(c.id)), 1 /* TEXT */)
                                ]),
                                _createElementVNode("td", null, [
                                  (c.isGoal)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, "100"))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_17, [
                                        (!hasDirtyWeights.value)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(c.localWeight), 1 /* TEXT */))
                                          : _createCommentVNode("v-if", true)
                                      ]))
                                ]),
                                _createElementVNode("td", null, [
                                  (c.isGoal)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, "100"))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_20, [
                                        (!hasDirtyWeights.value)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(c.globalWeight), 1 /* TEXT */))
                                          : _createCommentVNode("v-if", true)
                                      ]))
                                ])
                              ]))
                            }), 128 /* KEYED_FRAGMENT */))
                          ])
                        ])
                      ], 32 /* NEED_HYDRATION */)
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: close,
                  class: "btn btn-outline-secondary"
                }, "Cancel"),
                (hasDirtyWeights.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      onClick: emitNormalizeWeights,
                      class: "btn btn-warning"
                    }, "Normalize"))
                  : _createCommentVNode("v-if", true),
                _cache[6] || (_cache[6] = _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-primary",
                  form: "weights-set-editor-form"
                }, "Save", -1 /* CACHED */))
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})